import React from "react";

const Button = ({
  type,
  disabled = false,
  onClick,
  icon = false,
  label,
  rounded = "",
  width = "",
  borderColor = "",
  textColor = "",
  backgroundColor = "",
  hoverBackgroundColor = "",
  focusRingColor = "",
  focusRingOpacity = "",
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`flex justify-center items-center font-medium px-2 py-3 border focus:outline-none focus:ring-2 focus:ring-offset-2 ${rounded} ${width} ${borderColor} ${textColor} ${backgroundColor} ${hoverBackgroundColor} ${focusRingColor} ${focusRingOpacity} ${className}`}
    >
      {icon && icon}
      {label}
    </button>
  );
};

export default Button;
